import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import { Card, Badge, Space, Flex, Empty } from "antd";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Car from "../../../img/asset/car.png";
import "leaflet-rotatedmarker";
import Utilities from "../../dependencies/custom/react-utilities";
import Settings from "../../dependencies/custom/settings";
import { useNavigate } from "react-router-dom";

// Vehicle icon
const vehicleIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/61/61168.png",
  // iconUrl: Car,
  iconAnchor: [20, 20], // center so rotation is correct
  iconSize: [30, 30],
});

function interpolatePosition(start, end, t) {
  return [
    start[0] + (end[0] - start[0]) * t,
    start[1] + (end[1] - start[1]) * t,
  ];
}

const DEFAULT_CENTER = [0.3476, 32.5825];

// Map auto-follow component
function FollowVehicle({ position }) {
  const map = useMap();
  useEffect(() => {
    if (position) map.setView(position, map.getZoom(), { animate: true });
  }, [position, map]);
  return null;
}

export default function VehicleTrackerWithStops() {
  const navigate = useNavigate();

  const [vehicles, setVehicles] = useState([]);

  const [activeVehicleId, setActiveVehicleId] = useState();
  const activeVehicle = vehicles.find((v) => v?.busID === activeVehicleId);
  const trackedVehicles = vehicles.filter((v) =>
    Array.isArray(v?.currentPosition),
  );
  const mapCenter =
    activeVehicle?.currentPosition ||
    trackedVehicles[0]?.currentPosition ||
    DEFAULT_CENTER;

  useEffect(() => {
    if (vehicles.length && !activeVehicleId) {
      setActiveVehicleId(vehicles[0]?.busID);
    }
  }, [vehicles, activeVehicleId]);

  useEffect(() => {
    getActiveTrips();
  }, []);

  async function getActiveTrips() {
    const res = await Utilities.fetchWithAuth(
      "GET",
      Settings.urls.transport.active_trips,
      undefined,
      navigate,
    );

    if (res?.ok) {
      const buses = res?.data?.map((v) => {
        return {
          tripID: v?.id,
          busID: v?.busID,
          busPlate: v?.busPlate,
          numberOfStudents: v?.numberOfStudents,
          routeName: v?.routeName,
          color: Utilities.getRandomColor(),
          path: [],
          currentPosition: null,
          targetPosition: null,
        };
      });

      setVehicles(buses || []);
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
  }

  useEffect(() => {
    try {
      const ws = new WebSocket(
        `wss://${Settings.domain}/ws/trips/monitor/?token=${Utilities.getCookie("access")}`,
      );

      ws.onopen = () => {
        console.log("GPS WebSocket connected");
      };

      ws.onmessage = (event) => {
        const data = JSON.parse(event?.data);
        const latitude = parseFloat(data?.latitude);
        const longitude = parseFloat(data?.longitude);
        const incomingBusId = data?.bus_id;
        const incomingTripId = data?.trip_id ?? data?.tripID;

        if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
          return;
        }

        setVehicles((prev) =>
          prev.map((v) => {
            const matchesBus =
              incomingBusId !== undefined &&
              incomingBusId !== null &&
              incomingBusId !== "" &&
              (String(v?.busID) === String(incomingBusId) ||
                String(v?.busPlate || "").trim() ===
                  String(incomingBusId).trim());
            const matchesTrip =
              incomingTripId !== undefined &&
              incomingTripId !== null &&
              incomingTripId !== "" &&
              String(v?.tripID) === String(incomingTripId);

            if (!matchesBus && !matchesTrip) return v;

            const newTarget = [latitude, longitude];

            return {
              ...v,
              currentPosition: v?.currentPosition || newTarget,
              targetPosition: newTarget,
              path: [...(v?.path || []), newTarget],
            };
          }),
        );
      };

      ws.onerror = (err) => console.error("GPS WS error:", err);

      ws.onclose = () => {
        console.log("GPS WebSocket closed");
      };

      return () => ws.close();
    } catch (err) {
      console.log(err.message);
    }
  }, []);

  // Animate markers smoothly ~60fps: move currentPosition towards targetPosition (interpolation)
  useEffect(() => {
    const anim = setInterval(() => {
      setVehicles((prev) =>
        prev.map((v) => {
          const start = v.currentPosition;
          const end = v.targetPosition;

          if (!Array.isArray(end)) return v;
          if (!Array.isArray(start)) {
            return { ...v, currentPosition: end };
          }

          const dist = Math.hypot(start[0] - end[0], start[1] - end[1]);

          if (dist < 1e-6) return v;
          const fraction = Math.min(0.2, dist * 5);
          const newPos = interpolatePosition(start, end, fraction);
          return { ...v, currentPosition: newPos };
        }),
      );
    }, 16);
    return () => clearInterval(anim);
  }, []);

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <Card
        title="Tracked Buses"
        style={{ width: 220, marginRight: 20, overflowY: "auto" }}
      >
        <Flex vertical gap="small">
          {vehicles.map((v) => (
            <div
              className="rounded"
              onClick={() => setActiveVehicleId(v?.busID)}
              style={{
                cursor: "pointer",
                background: v?.busID === activeVehicleId ? "#f0f5ff" : "white",
                padding: 12,
              }}
              key={v?.busID}
            >
              <Space>
                <Badge color={v.color} />
                <strong>
                  {v?.busPlate} {v?.routeName}
                </strong>
              </Space>
            </div>
          ))}
        </Flex>

        {/* <List
                    dataSource={vehicles}
                    renderItem={(v) => {
                        return (
                            <List.Item
                                onClick={() => setActiveVehicleId(v?.busID)}
                                style={{
                                    cursor: "pointer",
                                    background: v?.busID === activeVehicleId ? "#f0f5ff" : "white",
                                    padding: 12,
                                }}
                            >
                                <List.Item.Meta
                                    title={
                                        <Space>
                                            <Badge color={v.color} />
                                            <strong>{v?.busPlate} {v?.routeName}</strong>
                                        </Space>
                                    }
                                />
                            </List.Item>
                        );
                    }}
                /> */}
      </Card>

      <div style={{ flex: 1 }}>
        {!activeVehicle ? (
          <Empty
            className="mt-5"
            description={"No Buses to Track"}
            image={Car}
          />
        ) : trackedVehicles.length === 0 ? (
          <Empty
            className="mt-5"
            description={"Waiting for GPS updates"}
            image={Car}
          />
        ) : (
          <MapContainer
            center={mapCenter}
            zoom={16}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              attribution="© OpenStreetMap contributors"
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {/* Follow selected vehicle */}
            <FollowVehicle
              position={
                activeVehicle?.currentPosition ||
                trackedVehicles[0]?.currentPosition
              }
            />

            {/* Render vehicles and their paths */}
            {trackedVehicles.map((v) => (
              <React.Fragment key={v?.busID}>
                <Marker
                  position={v?.currentPosition}
                  icon={vehicleIcon}
                  rotationOrigin="center"
                >
                  <Popup>
                    <div>
                      <strong>
                        {v?.busPlate} {v?.routeName}
                      </strong>
                      <div>Latitude: {v?.currentPosition?.[0]?.toFixed(5)}</div>
                      <div>
                        Longitude: {v?.currentPosition?.[1]?.toFixed(5)}
                      </div>
                    </div>
                  </Popup>
                </Marker>

                {/* <Polyline positions={v.path} color={v.color} /> */}
              </React.Fragment>
            ))}
          </MapContainer>
        )}
      </div>
    </div>
  );
}
